export const sliderMoveDirections = {
    left: -1,
    right: 1,
};